import { useState } from 'react'

import { EMPTY_FUNCTION_ASYNC } from '../../../../constants/common'
import { UserProfileWidgetFinancialDetails } from '../../../User'
import { Component, ComponentProps } from '../../Component'
import { boolean, controls, json } from '../../Controls'
import { MOCK_INFO_OPTIONS } from '../InhabitantProfile.constants'

import { PROFILE_FINANCIAL_DETAILS_INHABITANT_DATA } from './ProfileFinancialDetailsWidgetInhabitant.constants'

function ProfileFinancialDetailsWidgetInhabitant() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('canEdit', true))
      .add(json('data', PROFILE_FINANCIAL_DETAILS_INHABITANT_DATA))
      .add(boolean('isSkeleton', false))
      .add(json('options', MOCK_INFO_OPTIONS))
  )

  return (
    <>
      <Component
        {...props.getValues()}
        Component={UserProfileWidgetFinancialDetails}
        name='UserProfileWidgetFinancialDetails'
        onSubmit={EMPTY_FUNCTION_ASYNC}
      />
      <ComponentProps
        name='UserProfileWidgetFinancialDetails'
        value={props}
        onChange={setProps}
      />
    </>
  )
}

export default ProfileFinancialDetailsWidgetInhabitant
